import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gstar-body-modal',
  templateUrl: './body-modal.component.html',
  styleUrls: ['./body-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BodyModalComponent {
  overflowHidden = input<boolean>(false);
}
